import React from 'react'
import logo from '../../../img/solimat-logo.svg'
import PageMenu from '../../blocks/PageMenu/PageMenu'
import './lopd.scss'

const ReviewMark = ({ children }) => <span className="lopd-needs-review">{children}</span>

const SeparatorReverse = () => {
    return (
        <section className="separator-triangle-reverse"></section>
    )
}

const LOPD = () => {
    return (
        <>
            <header className="header-new-block">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="header-new-content">
                                <div className="logo-new-block">
                                    <div className="logo-new-container">
                                        <img src={logo} className="logo-new" alt="solimat" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <PageMenu title={'LOPD y RGPD'}></PageMenu>

            <br />
            <br />

            <div className="container lopd-container">
                <article className="lopd-card">
                    <h1>Politica de Proteccion de Datos (LOPDGDD y RGPD)</h1>
                    <p className="lead">
                        
                            Esta politica describe como se tratan los datos personales de pacientes, personas trabajadoras,
                            empresas asociadas y otros usuarios del Portal del Paciente de SOLIMAT, Mutua Colaboradora con la
                            Seguridad Social numero 72.
                        
                    </p>

                    <section className="summary-box" aria-label="Informacion basica de proteccion de datos">
                        <p><strong>Responsable:</strong> SOLIMAT Mutua Colaboradora con la Seguridad Social numero 72 (CIF G45032844).</p>
                        <p><strong>Domicilio:</strong> Calle Berna, 1, 45003, Toledo (Espana).</p>
                        <p><strong>Contacto general:</strong> +34 925 28 31 86.</p>
                        <p><strong>Delegado de Proteccion de Datos (DPD):</strong> <a href="mailto:lopd@solimat.com">lopd@solimat.com</a>.</p>
                    </section>

                    <h2>1. Normativa aplicable</h2>
                    <p>
                        
                            El tratamiento de datos personales se realiza conforme al Reglamento (UE) 2016/679 (RGPD), la Ley
                            Organica 3/2018, de Proteccion de Datos Personales y garantia de los derechos digitales (LOPDGDD), la
                            Ley 41/2002, basica reguladora de la autonomia del paciente y demas normativa sanitaria y de Seguridad
                            Social aplicable a las Mutuas Colaboradoras.
                        
                    </p>

                    <h2>2. Que datos tratamos</h2>
                    <p>Podemos tratar, segun el servicio utilizado, las siguientes categorias de datos:</p>
                    <ul>
                        <li>Datos identificativos y de contacto (nombre, apellidos, DNI/NIE, telefono, email, direccion).</li>
                        <li>Datos de afiliacion, cobertura y relacion con la Seguridad Social.</li>
                        <li>Datos de salud (historia clinica, pruebas diagnosticas, informes, tratamientos).</li>
                        <li>Datos administrativos, economicos y de facturacion vinculados a la prestacion asistencial.</li>
                        <li>Datos de uso del portal y trazas tecnicas (logs de acceso, dispositivos, fecha y hora).</li>
                        <li>Datos de geolocalizacion, solo cuando el usuario activa ese permiso y para finalidades concretas.</li>
                    </ul>
                    <p> 
                        Carácter obligatorio de los datos. Los datos solicitados que resulten necesarios para prestar asistencia sanitaria, 
                        gestionar las prestaciones de Seguridad Social o cumplir las obligaciones legales de SOLIMAT tendrán carácter obligatorio. 
                        La negativa a facilitarlos podrá impedir, cuando resulte necesario, la correcta prestación del servicio, la tramitación de la prestación o el cumplimiento de la obligación correspondiente. 
                        Los datos solicitados para funcionalidades opcionales del Portal tendrán carácter voluntario.
                    </p>
                    <h2>3. Finalidades y bases juridicas del tratamiento</h2>
                    <table className="legal-table" aria-label="Finalidades y bases juridicas">
                        <thead>
                            <tr>
                                <th>Finalidad</th>
                                <th>Base juridica (art. 6 RGPD)</th>
                                <th>Categoria especial (art. 9 RGPD)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Prestacion sanitaria, gestion de citas, historia clinica y continuidad asistencial.</td>
                                <td>Cumplimiento de obligacion legal y mision de interes publico; en su caso, ejecucion de la relacion asistencial.</td>
                                <td>Tratamiento necesario para fines de medicina asistencial y gestion de sistemas y servicios sanitarios.</td>
                            </tr>
                            <tr>
                                <td>Gestion administrativa, tramitacion de prestaciones y cumplimiento de obligaciones con organismos publicos.</td>
                                <td>Cumplimiento de obligaciones legales y ejercicio de poderes publicos conforme a normativa de Seguridad Social.</td>
                                <td>Cuando proceda, tratamiento necesario por razones de interes publico esencial en el ambito sanitario y social.</td>
                            </tr>
                            <tr>
                                <td>Atencion de consultas, reclamaciones y ejercicio de derechos de proteccion de datos.</td>
                                <td>Cumplimiento de obligacion legal y, en su caso, interes legitimo en la gestion de la relacion con el usuario.</td>
                                <td>No aplica, salvo que la solicitud incluya datos de salud.</td>
                            </tr>
                            <tr>
                                <td>Prevencion, mejora de calidad asistencial, seguridad del paciente y auditorias internas.</td>
                                <td>Interes legitimo y cumplimiento de obligaciones legales en materia sanitaria y de calidad asistencial.</td>
                                <td>Tratamiento con garantias adecuadas para fines sanitarios y de gestion de servicios de salud.</td>
                            </tr>
                            <tr>
                                <td>Investigacion cientifica y estadistica, con tecnicas de anonimizacion o seudonimizacion siempre que sea posible.</td>
                                <td>Interes publico en investigacion y cumplimiento del marco normativo aplicable; en su caso, consentimiento.</td>
                                <td>Tratamiento para investigacion cientifica con medidas reforzadas y minimizacion de datos.</td>
                            </tr>
                            <tr>
                                <td>Servicios de geolocalizacion dentro del portal o app.</td>
                                <td>Consentimiento del interesado, revocable en cualquier momento.</td>
                                <td>No aplica por si misma, salvo combinacion con datos sanitarios.</td>
                            </tr>
                        </tbody>
                    </table>

                    <h2>4. De donde proceden los datos</h2>
                    <ul>
                        <li>Del propio interesado o su representante legal.</li>
                        <li>De profesionales sanitarios y personal administrativo en el marco de la asistencia.</li>
                        <li>De organismos o entidades legitimadas legalmente para comunicar datos a la Mutua.</li>
                        <li>De sistemas y aplicaciones utilizados para la prestacion de servicios sanitarios y administrativos.</li>
                    </ul>

                    <h2>5. Destinatarios y cesiones de datos</h2>
                    <p>
                        
                            Los datos podran comunicarse, cuando sea necesario y siempre con base juridica suficiente, a:
                        
                    </p>
                    <ul>
                        <li>Administraciones Publicas, Seguridad Social, autoridades sanitarias y organos judiciales.</li>
                        <li>Centros y profesionales sanitarios que participen en su asistencia.</li>
                        <li>Encargados del tratamiento que prestan servicios a SOLIMAT (tecnologia, archivo, soporte, auditoria, etc.).</li>
                    </ul>
                    <p>                        
                        Los proveedores que actúen como encargados del tratamiento lo harán conforme a un contrato de encargo de tratamiento de acuerdo con el artículo 28 RGPD y siguiendo las instrucciones documentadas de SOLIMAT. 
                        Determinados centros o profesionales sanitarios podrán actuar como responsables independientes del tratamiento cuando así resulte de las funciones y obligaciones que les atribuya la normativa sanitaria.
                    </p>

                    <h2>6. Transferencias internacionales</h2>
                    <p>
                        
                            Con caracter general, no se realizan transferencias internacionales de datos fuera del Espacio Economico
                            Europeo. Si para un servicio concreto fuera necesario realizarlas, se aplicaran las garantias exigidas
                            por el RGPD (por ejemplo, clausulas contractuales tipo o decision de adecuacion), y se informara al
                            interesado de forma especifica.
                        
                    </p>

                    <h2>7. Plazos de conservacion</h2>
                    <ul>
                        <li>Los datos se conservaran durante el tiempo necesario para cada finalidad.</li>
                        <li>La documentacion clinica se conservara, como minimo, durante los plazos exigidos por la normativa sanitaria aplicable y, en todo caso, mientras puedan derivarse responsabilidades legales.</li>
                        <li>Datos de geolocalizacion: hasta la retirada del consentimiento o desactivacion del permiso.</li>
                        <li>Datos para atencion de derechos o reclamaciones: durante la tramitacion y los plazos de prescripcion legal.</li>
                        <li>Finalizados los plazos, los datos se suprimiran o bloquearan segun la normativa vigente.</li>
                    </ul>

                    <h2>8. Derechos de las personas interesadas</h2>
                    <p>Puede ejercer los derechos de:</p>
                    <ul>
                        <li>Acceso.</li>
                        <li>Rectificacion.</li>
                        <li>Supresion.</li>
                        <li>Oposicion.</li>
                        <li>Limitacion del tratamiento.</li>
                        <li>Portabilidad (cuando proceda).</li>
                        <li>Retirada del consentimiento en cualquier momento, sin efectos retroactivos.</li>
                    </ul>
                    <p>
                        
                            Para ejercerlos puede dirigirse al DPD en <a href="mailto:lopd@solimat.com">lopd@solimat.com</a> o por
                            correo postal a la direccion del responsable, indicando en el asunto "Proteccion de Datos - Ejercicio de
                            Derechos" e incorporando la documentacion de identificacion necesaria.
                        
                    </p>
                    <p>
                        
                          Para ejercer estos derechos podrá dirigirse al DPD en lopd@solimat.com o por correo postal a la dirección del responsable. SOLIMAT podrá solicitar información adicional únicamente cuando existan dudas razonables sobre la identidad de la persona solicitante, y exclusivamente en la medida necesaria para confirmar dicha identidad.
 
                    </p>

                    <h2>9. Decisiones automatizadas y perfiles</h2>
                    <p>
                        
                            Con caracter general, no se adoptan decisiones individuales automatizadas ni se elaboran perfiles con
                            efectos juridicos sobre las personas usuarias. Si se implantara algun proceso de este tipo, se informara
                            previamente conforme al RGPD.
                        
                    </p>

                    <h2>10. Seguridad y confidencialidad</h2>
                    <p>
                        
                            SOLIMAT aplica medidas tecnicas y organizativas apropiadas para garantizar la confidencialidad,
                            integridad, disponibilidad y resiliencia de los datos personales, incluyendo control de acceso,
                            trazabilidad, cifrado cuando corresponde y politicas de gestion de incidentes de seguridad.
                        
                    </p>

                    <h2>11. Menores y representacion legal</h2>
                    <p>
                        
                            Cuando la persona paciente sea menor de edad o no tenga plena capacidad de obrar, el tratamiento y el
                            ejercicio de derechos se ajustaran a la normativa sanitaria y civil aplicable, mediante su
                            representacion legal cuando proceda.
                        
                    </p>

                    <h2>12. Actualizacion de esta politica</h2>
                    <p>
                        
                            Esta politica puede actualizarse para adaptarse a cambios normativos o funcionales del Portal del
                            Paciente. En caso de modificaciones relevantes, se informara por los canales habituales.
                        
                    </p>

                    <p className="last-update"><strong>Fecha de ultima actualizacion:</strong> 07/08/2026</p>

                </article>
            </div>

            <SeparatorReverse />
        </>
    )
}

export default LOPD

